import {
  IEnableWhen,
  IImageUrls,
  InputType,
  QuestionnaireType,
} from "@gloria-public/questionnaire/domain/interfaces/questionnaire-common.interface";
import { EditorStatus, ICoding, IIdentifierFhir, IReferenceFhir } from "@shared/interfaces/shared.interface";

export interface IQuestionnaireSerializable {
  resourceType: string;
  version: string; // language string
  identifier: IIdentifierFhir;
  contained: IValueSet[];
  date: string;
  status: EditorStatus;
  publisher?: string;
  telecom?: IIdentifierFhir[];
  subjectType: string;
  group: IQuestionsGroup;
  specificUse: QuestionnaireType;
  successThreshold?: number;
  knowledgeId?: string;
  mediaId?: string;
  paging?: QuestionnairePaging;
  manualTransition?: boolean;
  questionByGroup?: boolean;
}

export interface IValueSet {
  resourceType: string;
  version?: string;
  name?: string;
  status: string;
  description: string;
  idSet: string;
  id?: string;
  compose: IComposeObject;
}

export interface IQuestionsGroup {
  linkId: string;
  title: string;
  concept: ICoding[];
  text?: string;
  required?: boolean;
  repeats?: boolean;
  group?: IQuestionsGroup[];
  question?: IQuestion[];
}

export interface IQuestion {
  linkId: string;
  concept: ICoding[];
  text: string;
  imageUrls?: IImageUrls;
  type: InputType;
  required?: boolean;
  repeats?: boolean;
  enableWhen?: IEnableWhen[];
  answerDisplay?: IAnswerDisplay;
  enableWhenBehavior?: EnableWhenBehavior;
  options: IReferenceFhir;
  option?: ICoding[];
}

interface IComposeObject {
  include: IComposeInclude[];
}

interface IComposeInclude {
  system: string;
  concept: IConcept[];
}

interface IConcept {
  code: string;
  display: string;
  infotip?: string;
  userSelected?: boolean;
}

interface IAnswerDisplay {
  type?: InputType;
  showMethod?: number;
  scaleReverseValue?: boolean;
  min?: string;
  max?: string;
  step?: number;
  default?: string;
  displayIsShown?: boolean;
  placeholder?: string;
  goodAnswers?: string[];
  textPass?: string;
  textFailed?: string;
  multiInputs?: boolean;
  nameSmiley?: NameSmiley;
}

export enum QuestionnairePaging {
  NONE = "NONE",
  SINGLE = "SINGLE",
  GROUP = "GROUP",
}

export enum EnableWhenBehavior {
  AND = "all",
  OR = "any",
}

enum NameSmiley {
  FACE = "smileyFace",
  CHILD = "smileyChild",
}
